import { useAuth } from "../../../../context/AuthContext";
import CreateProject from "../project-crud/CreateProject";
import CreateAmsProject from "../../../amsProject/pages/project-crud/CreateAmsProject";

export default function ProjectCreateRouter() {
    const { activeDepartment } = useAuth();

    if (activeDepartment === 'AMS') {
        return <CreateAmsProject />;
    }

    return <CreateProject />;
}
